export const APP_DRAWERS_MERCHANT_PORTAL_APP_ID = 2;

export default { APP_DRAWERS_MERCHANT_PORTAL_APP_ID };
